<template>
  <div class="summary-bar-item-badge">
    <button
      v-if="isRemovable"
      class="badge-content is-remove"
      aria-label="Remove selected item"
      data-testid="summary-bar-remove-item"
      type="button"
      @click.stop="$emit('remove')"
    >
      <Icon :icon="csgClear" size="m" />
    </button>
    <button
      v-else-if="errorMessage"
      v-tooltip.bottom="errorMessage"
      class="badge-content is-error"
      data-testid="summary-bar-thumbnail-badge-error"
      type="button"
      tabindex="0"
      :aria-label="`Error adding item to bag: ${errorMessage}`"
      @click.stop="handleErrorClick"
      @touchstart.stop="handleErrorClick"
    >
      <Icon :icon="csgErrorRed" size="m" />
    </button>
    <div v-else-if="quantity > 1" class="badge-content is-quantity" data-testid="summary-bar-thumbnail-badge-quantity">
      {{ quantity }}
    </div>
  </div>
</template>

<script setup lang="ts">
import Icon from '@atomic-ui/icon/Icon.vue';
import { csgErrorRed, csgClear } from '@csgSvgIcons/icons';

defineProps<{
  quantity: number;
  errorMessage?: string;
  isRemovable?: boolean;
}>();

defineEmits<{
  (e: 'remove'): void;
}>();

const handleErrorClick = (e: Event) => {
  (e.currentTarget as HTMLElement)?.focus();
};
</script>

<style lang="scss" scoped>
@import '~settingSCSS';

.summary-bar-item-badge {
  position: absolute;
  top: rem-calc(2);
  right: rem-calc(2);
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;

  > * {
    pointer-events: auto;
  }
}

.badge-content {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: $black;
  box-sizing: border-box;
  padding: 0;

  &.is-remove {
    background: $white;
    width: rem-calc(24);
    height: rem-calc(24);
    border: none;
    cursor: pointer;
  }

  &.is-error {
    background: $white;
    width: auto;
    height: auto;
    border: none;
    cursor: pointer;
    margin: rem-calc(2);
  }

  &.is-quantity {
    background: $white-overlay-color-2;
    min-width: rem-calc(20);
    height: rem-calc(20);
    border: 1px solid $gray-2-color;
    font-size: rem-calc(14);
    line-height: 1;
    margin: rem-calc(2);
  }
}
</style>
